import React from 'react'
import { Line, Step, StepperContainer } from '../style'

interface Props {
  steps: number
  className?: string
}

const Stepper = ({ steps, className }: Props) => {
  return (
    <StepperContainer className={className}>
      <Line />
      {Array.from({ length: steps }).map((_, index) => {
        return <Step key={index}>{index + 1}</Step>
      })}
    </StepperContainer>
  )
}

export default Stepper
